import React from "react"
import PropTypes from "prop-types"

import moment from "moment"
import { post } from "shared/lib/api"

export const Activity = ({ connection, activityURL, checkConnectionURL }) => {
  const {
    id,
    config_type,
    status,
    created_at,
    last_run,
    run_count,
    speed,
  } = connection

  // queries
  function getCheckConnectionAction() {
    const paused = connection.channels.filter(c => c.is_paused)

    // disable the action if any services are paused
    if (paused.length !== 0) {
      return {
        label: getPausedLabel(paused),
        call: null,
      }
    }

    // otherwse, this can be checked
    return {
      label: speed,
      call() {
        post(checkConnectionURL)
          .then(() => window.appendFlash("Check completed"))
          .catch(() =>
            window.appendFlash(
              "There was a problem checking this Applet.",
              "danger"
            )
          )
      },
    }
  }

  function getPausedLabel(services) {
    const names = services.map(c => c.name).join(" & ")
    const pluralized = services.length > 1 ? "services are" : "service is"
    return `${names} ${pluralized} <a class="with-decoration" target="_blank" href="https://ift.tt/paused-services" title="Learn more about paused services">currently paused</a>.`
  }

  // render
  const isStaticApplet = config_type === "static"
  const checkConnectionAction = getCheckConnectionAction()

  return (
    status !== "never_enabled_for_user" &&
    (created_at || last_run || run_count) && (
      <>
        <div className="connection-view-activity">
          <div className="connection-list-activity">
            <p className="txt-body-3">Check the log of your Applet runs</p>
            <a
              role="button"
              className="button-tertiary button-outlined"
              href={activityURL}
              data-track-ifttt-next-event="click"
              data-track-data={JSON.stringify({
                object_type: "connection_activity_log",
                object_id: `${id}`,
                location_type: "connection_config",
              })}
            >
              View activity
            </a>
          </div>

          {isStaticApplet && (
            <div className="connection-check">
              <p
                className="txt-body-3 advise"
                dangerouslySetInnerHTML={{
                  __html: checkConnectionAction.label,
                }}
              />
              <button
                className="button-tertiary button-outlined"
                disabled={checkConnectionAction.call == null}
                title="IFTTT will check the trigger service and run the actions if new events are returned"
                onClick={checkConnectionAction.call}
                data-track-ifttt-next-event="click"
                data-track-data={JSON.stringify({
                  object_type: "connection_activity_check_now",
                  object_id: `${id}`,
                  location_type: "connection_config",
                })}
              >
                Check now
              </button>
            </div>
          )}
        </div>
      </>
    )
  )
}

export const RecentActivity = ({
  connection: { config_type, created_at, last_run, run_count },
}) => {
  const isStaticApplet = config_type === "static"

  if (
    status == "never_enabled_for_user" ||
    !(created_at || last_run || run_count)
  ) {
    return null
  }

  return (
    <div className="recent-activity txt-body-3">
      {created_at && (
        <p>
          Connected{" "}
          {moment(created_at, "YYYY-MM-DD HH:mm:ss ZZZZ").format(
            "MMM DD, YYYY"
          )}
        </p>
      )}

      {isStaticApplet && (
        <>
          {last_run && (
            <p>
              Last activity{" "}
              {moment(last_run, "YYYY-MM-DD HH:mm:ss ZZZZ").format(
                "MMM DD, YYYY"
              )}
            </p>
          )}

          {run_count ? (
            <p>
              Run {run_count} time{run_count > 1 && <span>s</span>}
            </p>
          ) : (
            <p>Never run</p>
          )}
        </>
      )}
    </div>
  )
}

Activity.propTypes = {
  connection: PropTypes.shape({
    id: PropTypes.string,
    config_type: PropTypes.string,
    created_at: PropTypes.string,
    last_run: PropTypes.string,
    run_count: PropTypes.number,
    status: PropTypes.string,
    speed: PropTypes.string,
    channels: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        is_paused: PropTypes.bool,
      })
    ),
  }),
  activityURL: PropTypes.string,
  checkConnectionURL: PropTypes.string,
  userTier: PropTypes.string,
}

RecentActivity.propTypes = {
  connection: PropTypes.shape({
    config_type: PropTypes.string,
    created_at: PropTypes.string,
    last_run: PropTypes.string,
    run_count: PropTypes.number,
  }),
}
